module.exports = __webpack_public_path__ + "img/Lot8.5f08638f.jpg";